import {prop, sortBy} from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import BootstrapSelect from 'iss/widgets/bootstrap/Select';
import archiveActivation from 'iss/widgets/batchOps/activation/archiveActivation';
import cancelEvents from 'iss/widgets/batchOps/activation/cancelEvents';
import createEvents from 'iss/widgets/batchOps/activation/createEvents';
import modifyParties from 'iss/widgets/batchOps/activation/modifyParties';
import modifyRecurrences from 'iss/widgets/batchOps/activation/modifyRecurrences';

const batchOps = [
  archiveActivation, modifyParties, cancelEvents, createEvents, modifyRecurrences
];

export function ActivationBatchOpChooser({onChoose}) {
  const options = batchOps
    .filter(op => ("canAccess" in op) ? op.canAccess() : true)
    .map((operation) => ({label: translate(operation.title), value: operation}));
  return <BootstrapSelect id="batchopChooser" options={sortBy(prop("label"), options)} onChange={({value}) => onChoose(value)}/>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/ActivationBatchOps.jsx